import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { SESSION_STORAGE_KEYS } from '../types/types';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private sharedService: SharedService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.isAuthenticated()) {
      return this.redirectToLogin();
    }
    return true;
  }

  private isAuthenticated(): boolean {
    return !!(
      this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.SESSION_TOKEN) 
      // && this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TENANT_DETAILS,'SESSION')
    );
  }

  private redirectToLogin(): UrlTree {
    return this.router.createUrlTree(['/home']);
  }
}
